import React from 'react';
import { Route, Routes } from 'react-router-dom';  // Don't import BrowserRouter here
import Home from './components/Home';
import MetricGenerator from './components/MetricGenerator';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';

import Contact from './components/Contact';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop'; // Import the ScrollToTop component

class App extends React.Component {
  render() {
    return (
      <>
        <Header />
        <ScrollToTop /> {/* Add the ScrollToTop component */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/metric-generator" element={<MetricGenerator />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        </Routes>
      </>
    );
  }
}

export default App;